/*养殖日志模块接口*/
const axios = require('axios')
const qs = require('qs')

const {STABLE_LIST_URL,DAILY_TABLE_LIST_URL,STABLE_TABLE_LIST_URL,INSPECTION_TABLE_URL,
    PURCHASE_TABLE_URL,SALES_TABLE_URL,DAILY_POND_LIST_URL,INSPECTION_NAME_LIST_URL,PURCHASE_ACCOUNT_URL,
    SALES_ACCOUNT_LIST_URL,STABLE_ADD_TABLE_LIST_URL,PURCHASE_TABLE_LIST_ADD_URL,SALES_TABLE_LIST_ADD_URL,
    INSPECTION_TABLE_LIST_ADD_URL,DAILY_TABLE_LIST_ADD_URL,STABLE_GET_SEEDLING_LIST_URL,FEED_URL,DRUG_URL,DAILY_GET_PESTICIDE_LIST_URL,
    STABLE_DELETE_URL,STABLE_UPDATE_URL,INSPECTION_DELETE_URL,INSPECTION_UPDATE_URL,DAILY_DELETE_AND_UPDATE_URL} = require('./url')
const axiosHeader = require('./auth')

/*固定收入模块*/
/*获取固定收入-->添加固定成本-->投入品类型*/
function fixedNameList() {
    return new Promise((resolve, reject) => {
        axios.get(STABLE_LIST_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*获取固定收入-->固定收入列表*/
function stableTableList(data){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(`${STABLE_TABLE_LIST_URL}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*获取固定收入-->添加固定收入*/
function stableTableListAdd({name,type,price,username,remark,sysTime,unit,count,total}) {
    return new Promise((resolve, reject) => {
        axios.post(STABLE_ADD_TABLE_LIST_URL, {
            name,type,price,username,remark,sysTime,unit,count,total
        })
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}
/*获取固定收入-->添加固定收入-->获取苗种列表*/
function getSeedlingList() {
    return new Promise((resolve, reject) => {
        axios.get(STABLE_GET_SEEDLING_LIST_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*获取固定收入-->删除某一项固定收入操作*/
/*获取购买记账-->删除某一项购买记账操作*/
/*获取销售记账-->删除某一项销售记账操作*/
function deleteStableIncome(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${STABLE_DELETE_URL}/${id}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*获取固定投入-->更新某一项固定收入操作*/
/*获取购买记账-->更新某一项购买记账操作*/
/*获取销售记账-->更新某一项销售记账操作*/
/*id,name,type,price,username,remark,sysTime,unit,count,total*/
function updateStableIncome(sendData) {
    return new Promise((resolve, reject) => {
        axios.put(STABLE_UPDATE_URL,{
            count:sendData.count,
            id:sendData.id,
            name:sendData.name,
            price:sendData.price,
            remark: sendData.remark,
            sysTime:sendData.sysTime,
            total:sendData.total,
            type:sendData.type,
            unit:sendData.unit,
            username: sendData.username
        })
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}


/*日常投入模块*/
/*日常投入-->日常投入列表*/
function dailyTableList(data){
    return new Promise((resolve, reject) => {
       axiosHeader.axiosStop()
        axios.get( `${DAILY_TABLE_LIST_URL}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*日常投入-->添加日常投入-->塘口名称列表*/
function getPondList(name) {
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(DAILY_POND_LIST_URL, {
            params: {
                username: name
            }
            })
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*日常投入-->添加日常投入*/
function dailyTableListAdd({total,cellId,description,type,username,sysTime,unit,count}) {
    return new Promise((resolve, reject) => {
        axios.post(DAILY_TABLE_LIST_ADD_URL, {
            total,cellId,description,type,username,sysTime,unit,count
        })
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}
/*日常投入-->添加日常投入-->获取饵料列表*/
function getPesticideList() {
    return new Promise((resolve, reject) => {
        axios.get(DAILY_GET_PESTICIDE_LIST_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*日常投入-->删除日常投入中的某一项*/
function deleteDailyIncome(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${DAILY_DELETE_AND_UPDATE_URL}/${id}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*日常投入-->更新日常投入某一项*/
function updateDailyIncome(sendData) {
    return new Promise((resolve, reject) => {
        axios.put(`${DAILY_DELETE_AND_UPDATE_URL}/${sendData.id}`,{
           cellId:sendData.cellId,
           count:sendData.count,
           description: sendData.description,
           sysTime:sendData.sysTime,
           total:sendData.total,
           type:sendData.type,
           unit:sendData.unit,
           username:sendData.username
        })
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}

/*巡视检查模块*/
/*巡视检查-->巡视检查列表*/
function inspectionTableList(data){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(`${INSPECTION_TABLE_URL}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*巡视检查-->添加巡视检查-->巡视事件类别*/
function inspectionNameList() {
    return new Promise((resolve, reject) => {
        axios.get(INSPECTION_NAME_LIST_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*巡视检查-->增加巡视检查*/
function inspectionTableListAdd({content,name,pound_id,time}) {
    return new Promise((resolve, reject) => {
        axios.post(INSPECTION_TABLE_LIST_ADD_URL, qs.stringify({
            content,name,pound_id,time
        }))
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}
/*巡视检查-->删除巡视检查*/
function  deleteInspection(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${INSPECTION_DELETE_URL}/${id}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*巡视检查-->更新巡视检查*/
function inspectionTableListUpdate({id,content,name,pound_id,time}) {
    return new Promise((resolve, reject) => {
        axios.post(INSPECTION_UPDATE_URL, qs.stringify({
            id,content,name,pound_id,time
        }))
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}


/*购买记账模块*/
/*购买记账-->购买记账列表*/
function purchaseTableList(data){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(`${PURCHASE_TABLE_URL}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*购买记账-->添加购买记账金额-->购买金额物品类型*/
function getPurchaseMoneyList() {
    return new Promise((resolve, reject) => {
        axios.get(PURCHASE_ACCOUNT_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*购买记账-->添加购买记账*/
function purchaseTableListAdd({name,total,remark,count,unit,type,username,sysTime}) {
    return new Promise((resolve, reject) => {
        axios.post(PURCHASE_TABLE_LIST_ADD_URL, {
            name,total,remark,count,unit,type,username,sysTime
        })
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}
/*购买记账--饵料*/
function getFeedList() {
  return new Promise((resolve, reject) => {
      axios.get(FEED_URL,{})
          .then(res => {
              //console.log(res);
              resolve(res.data)
          })
          .catch(err =>{
              reject(err)
          })
  })
}
/*购买记账--水质改良剂列表*/
function getDrugList() {
    return new Promise((resolve, reject) => {
        axios.get(DRUG_URL,{})
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}

/*销售记账模块*/
/*销售记账-->销售记账列表*/
function salesTableList(data){
    return new Promise((resolve, reject) => {
        axiosHeader.axiosStop()
        axios.get(`${SALES_TABLE_URL}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*销售记账-->销售记账列表-->销售记账类别列表*/
function salesAccountList(){
    return new Promise((resolve, reject) => {
        axios.get(SALES_ACCOUNT_LIST_URL)
            .then(function (response) {
                //console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                //console.log(error);
                reject(error)
            });
    })
}
/*销售记账-->添加销售记账*/
function salesTableListAdd({name,price,type,username,sysTime,remark,count,total}) {
    return new Promise((resolve, reject) => {
        axios.post(SALES_TABLE_LIST_ADD_URL, {
            name,price,type,username,sysTime,remark,count,total
        })
            .then(res => {
                //console.log(res);
                resolve(res.data)
            })
            .catch(err =>{
                reject(err)
            })
    })
}

module.exports = {
    fixedNameList,
    dailyTableList,
    stableTableList,
    inspectionTableList,
    purchaseTableList,
    salesTableList,
    getPondList,
    inspectionNameList,
    getPurchaseMoneyList,
    salesAccountList,
    stableTableListAdd,
    purchaseTableListAdd,
    salesTableListAdd,
    inspectionTableListAdd,
    dailyTableListAdd,
    getSeedlingList,
    getFeedList,
    getDrugList,
    getPesticideList,
    deleteStableIncome,
    updateStableIncome,
    deleteInspection,
    inspectionTableListUpdate,
    deleteDailyIncome,
    updateDailyIncome
}
